import { FC } from 'react';
import {
    Result,
    Table,
    Typography,
    Space,
    Button,
} from 'antd';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';

import { BulkResult, TranslateFn } from './types';

const { Text } = Typography;

interface ResultsStepProps {
    result: BulkResult;
    t: TranslateFn;
}

const ResultsStep: FC<ResultsStepProps> = ({ result, t }) => {
    const exportFailedRows = () => {
        if (!result.errors.length) return;

        const rows = result.errors.map((e) => ({
            [t('BULK.COL_ROW')]: e.row,
            [t('BULK.COL_EMAIL')]: e.email,
            [t('BULK.COL_ERROR')]: e.message,
        }));

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Errores');
        XLSX.writeFile(workbook, 'errores_importacion.xlsx');
    };

    const status = result.failed === 0 ? 'success' : 'warning';

    const columns = [
        {
            title: t('BULK.COL_ROW'), dataIndex: 'row', key: 'row', width: 80,
        },
        { title: t('BULK.COL_EMAIL'), dataIndex: 'email', key: 'email' },
        { title: t('BULK.COL_ERROR'), dataIndex: 'message', key: 'message' },
    ];

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Result
                status={status}
                title={t('BULK.RESULT_TITLE')}
                subTitle={(
                    <Space direction="vertical" size={4}>
                        <Text>{t('BULK.RESULT_TOTAL', { count: result.total })}</Text>
                        <Text type="success">{t('BULK.RESULT_SUCCESS', { count: result.successful })}</Text>
                        {result.failed > 0 && (
                            <Text type="danger">{t('BULK.RESULT_FAILED', { count: result.failed })}</Text>
                        )}
                    </Space>
                )}
            />

            {result.errors.length > 0 && (
                <>
                    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                        <Text strong>{t('BULK.FAILED_DETAILS')}</Text>
                        <Button
                            size="small"
                            icon={<FiDownload style={{ verticalAlign: 'middle', marginRight: 4 }} />}
                            onClick={exportFailedRows}
                        >
                            {t('BULK.EXPORT_ERRORS')}
                        </Button>
                    </Space>
                    <Table
                        dataSource={result.errors}
                        columns={columns}
                        rowKey="row"
                        size="small"
                        pagination={false}
                    />
                </>
            )}
        </Space>
    );
};

export { ResultsStep };
